import { render, staticRenderFns } from "./KeywordForm.vue?vue&type=template&id=7ac0e83b&"
import script from "./KeywordForm.vue?vue&type=script&lang=js&"
export * from "./KeywordForm.vue?vue&type=script&lang=js&"
import style0 from "./KeywordForm.vue?vue&type=style&index=0&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports